import { date } from 'quasar'

const LOAD_CONFIG_WRAPPER = {
  fileParallelism: 3
}

export default class ImageFilePreviewLoader {
  constructor () {
    this.files = []
    this.loadingCount = 0
    this.totalLoadingCount = 0
  }

  // public
  loadAll (fileWrappers, force) {
    fileWrappers.forEach(fileWrapper => this.load(fileWrapper, force))
  }

  // public
  load (fileWrapper, force) {
    if (force) {
      fileWrapper.smallBlobReloadRequired = true
    }
    this.files.push(fileWrapper)
    this.tryLoadNext()
  }

  // private
  tryLoadNext () {
    if (this.files.length !== 0 && this.loadingCount < LOAD_CONFIG_WRAPPER.fileParallelism) {
      const fileWrapper = this.files.shift()
      this.loadNext(fileWrapper)
    }
  }

  // private
  loadNext (fileWrapper) {
    if (!fileWrapper.smallUrl || fileWrapper.smallBlob && !fileWrapper.smallBlobReloadRequired) {
      this.tryLoadNext()
    } else {
      this.loadingCount++
      this.totalLoadingCount++
      // this.log(fileWrapper)

      this.loadFileThumbnail(fileWrapper)
        .catch(ignored => {})
        .finally(() => {
          this.loadingCount--
          this.tryLoadNext()
        })
    }
  }

  // private
  loadFileThumbnail (fileWrapper) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.responseType = 'blob'
      xhr.onload = (event) => {
        if (xhr.status >= 200 && xhr.status < 300) {
          if (fileWrapper.smallBlobReloadRequired) {
            fileWrapper.smallBlobReloadRequired = false
          }
          fileWrapper.smallBlob = URL.createObjectURL(xhr.response)
          resolve()
        } else {
          reject(new Error('Ошибка загрузки превью файла'))
        }
      }
      xhr.onerror = (event) => {
        reject(new Error('Ошибка загрузки превью файла'))
      }
      xhr.open('GET', fileWrapper.smallUrl, true)
      if (fileWrapper.smallBlobReloadRequired) {
        xhr.setRequestHeader('Cache-Control', 'no-cache, no-store, max-age=0')
      }
      xhr.send(null)
    })
  }

  log (file) {
    const time = date.formatDate(new Date(), 'HH:mm:ss.SSS')
    console.log(`Load: ${time}, ${this.loadingCount}, ${this.totalLoadingCount}`)
  }
}
